export default axiosInstance => ({
  /**
   * Return all categories Mirakl
   * @return {Promise} retour axios
   */
  async listMiraklTree() {
    return await axiosInstance.get("/market-place/categories");
  },

  /**
   * Return all categories Mirakl
   * @return {Promise} retour axios
   */
  async listMirakl(params) {
    return await axiosInstance.get("/mirakl_categories", { params });
  },

  /**
   * Return all categories Mirakl
   * @return {Promise} retour axios
   */
  async listLegacyCategories(params) {
    return await axiosInstance.get("/legacy_categories", { params });
  },

  /**
   * add catégrories Mirakl
   * @return {Promise} retour axios
   */
  async addCategorieMirakl(params) {
    return axiosInstance.post("/mirakl_categories", { ...params });
  },

  /**
   * catégrories Mirakl
   * @return {Promise} retour axios
   */
  async editCategorieMirakl(params, id) {
    return axiosInstance.put(`/mirakl_categories/${id}`, { ...params });
  },

  /**
   * Returns a Mirakl category
   * @param {Number} id - mirakl category id
   * @return {Promise} retour axios
   */
  async getMiraklCategoryLegacyCategories(id) {
    return axiosInstance.get(`/mirakl_categories/${id}/mapping_categories`);
  },

  /**
   * Returns the mappings of a Mirakl category
   * @param {Number} id - mirakl category id
   * @return {Promise} retour axios
   */
  async getMiraklCategory(id) {
    return axiosInstance.get(`/mirakl_categories/${id}`);
  },

  /**
   * Retourne les mappings d'une catégorie Mirakl
   * @param {Number} id - mirakl category id
   * @return {Promise} retour axios
   */
  async getMappingCategories(id) {
    return axiosInstance.get(`/mirakl_categories/${id}/mapping_categories`);
  },

  /**
   * post catégrories csv
   * @return {Promise} retour axios
   */
  async importCategoriesCsv(params) {
    let formData = new FormData();
    formData.append("file", params);
    return await axiosInstance.post("/mirakl_categories/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  /**
   * post catégrories csv
   * @return {Promise} retour axios
   */
  async addCategorieMapping(params) {
    return await axiosInstance.post("/category_mappings", { ...params });
  },

  /**
   * delete catégrories Mapping
   * @return {Promise} retour axios
   */
  async deleteCategorieMapping(id) {
    return await axiosInstance.delete(`/category_mappings/${id}`);
  }
});
